export default {
  name: '313C',
  recruitment_game: 'Jogo de Recrutamento',
  back: 'Voltar',
  cancel: 'Cancelar',
  continue: 'Continuar',
  skip: 'Ignorar',
  start: 'Iniciar',
  close: 'Fechar',
  help: 'Ajuda',
  time_left: 'Tempo restante',
  progress: 'Progresso',
  privacy_policy: 'Política de Privacidade',
  cookies_policy: 'Política de Cookies e Termos',
  faq: 'Perguntas e Respostas',
  messages: 'Mensagens',
  unread: 'não lida',
  start_recording: 'Iniciar gravação',
  stop_recording: 'Parar gravação',
  remove_record: 'Remover gravação',
  play_video: 'Reproduzir',
  stop_video: 'Parar',
  mute_video: 'Silenciar',
  unmute_video: 'Ativar som',
  replay_video: 'Reproduzir novamente',
  choose: 'Escolher',
  badges: {
    title: 'Emblemas',
    badge: 'Emblema',
    my_badges: 'Os meus Emblemas',
    received: 'Recebeste um emblema',
    continue: 'Continuar a jogar',
    show_badges: 'Ver emblemas',
    show_badge: 'Ver a recompensa',
  },
  record_test: {
    intro: 'TESTE DE DEFINIÇÕES DE CÂMARA E MICROFONE',
    content:
      'Antes de começares a usar a ferramenta, testa as tuas definições. No campo abaixo, deves ver a imagem da tua câmara. <strong>Se a vires</strong>, significa que as tuas definições estão muito provavelmente corretas - <strong>para teres a certeza, grava e reproduz um vídeo.</strong> Se não vires a imagem da câmara, não conseguires reproduzir a gravação ou tiveres outras dúvidas, clica no botão "RESOLVER PROBLEMAS".',
    troubleshoot: 'Resolver Problemas',
    settings: 'Definições',
  },
  questions: {
    progress: 'Pergunta',
    accept: 'Confirmar',
    question_counter: 'Pergunta <strong>{current}</strong> de <strong>{total}</strong>',
    time_for_answer: 'Tempo para responder',
    question_has_already_been_answered: 'Esta pergunta já foi respondida.',
  },
  not_found: {
    code: '404',
    title: 'A página não existe',
    content:
      'A página que procuravas não foi encontrada. Pode ter sido eliminada, ter mudado de nome ou nunca ter existido.',
  },
  phone: 'Número de telemóvel',
  select_language: 'Escolhe o idioma / Choose language',
  title:
    'Esta página utiliza cookies para te proporcionar uma excelente experiência de utilização. Ao utilizares a 313C, aceitas a nossa utilização de',
  link: 'cookies',
  button: 'Fechar',
  warning: {
    title: 'Ocorreu um erro',
    content: 'Tenta novamente e, se o erro persistir, avisa-nos em',
    content_without_email: 'Tenta novamente e, se o erro persistir, contacta o suporte técnico.',
    confirm: 'Fechar',
  },
  end_time: {
    title: 'Reportar um erro',
    content: 'Se ocorreu um erro durante o teu jogo, contacta-nos através do e-mail:',
  },
  record_video_error: {
    not_allowed_title: 'Sem permissões',
    not_allowed_desc:
      'Sem acesso à câmara e/ou microfone. Verifica as definições do teu navegador e concede as permissões necessárias.',
    not_found_title: 'Nenhum dispositivo ligado',
    not_found_desc:
      'Nenhuma câmara ou microfone detetado. Verifica se os teus dispositivos estão corretamente ligados.',
    not_readable_title: 'Dispositivo a ser utilizado por outra aplicação',
    not_readable_desc:
      'A câmara e/ou o microfone estão a ser utilizados por outra aplicação. Fecha-a e tenta novamente (pode ser necessário atualizar a página).',
    unknown_title: 'Erro desconhecido',
    unknown_desc:
      'Ocorreu um erro desconhecido (por exemplo, problemas de controladores ou dispositivo avariado). Consulta a secção de Resolução de Problemas e tenta novamente.',
    try_again: 'Atualizar página',
    corrupted_desc:
      'A gravação não foi guardada corretamente e a imagem congela durante a reprodução. Grave novamente a sua resposta.',
  },
  unsupported_os: {
    content: `
      <span class="swal2-title">Dispositivo não suportado</span>
      <hr>
      <div class="swal2-wrapper">
        <p>Para continuares, por favor utiliza <strong>outro dispositivo e/ou navegador.</strong></p>
        <p>A ferramenta de recrutamento que pretendes utilizar inclui pelo menos uma tarefa que requer que graves a tua resposta em formato de vídeo. Infelizmente, nem todos os dispositivos e/ou navegadores permitem fazer isso corretamente.</p>
        <p><strong>Se estás a ver este ecrã, significa que o teu dispositivo e/ou navegador não garantem a gravação e o envio corretos de um ficheiro de vídeo.</strong> Abaixo, encontrarás as configurações recomendadas.</p>
        <br>
        <p><strong>Computadores:</strong></p>
        <p>Windows: Google Chrome, Firefox, Opera, MS Edge</p>
        <p>macOS: Google Chrome, Firefox, Opera, Safari, MS Edge</p>
        <p>Ubuntu: Google Chrome, Firefox, Opera</p>
        <br>
        <p><strong>Dispositivos móveis:</strong></p>
        <p>Andriod: Google Chrome, Firefox, Opera</p>
        <p>iOS (iPhone/iPad): Safari</p>
      </div>
      <hr>
    `,
  },
  skip_stage_without_record: {
    title: 'Tens a certeza de que queres ignorar a tarefa?',
    content:
      '<p>A gravação de uma resposta em vídeo para esta tarefa não é obrigatória, mas é recomendada - ajudar-nos-á a conhecer-te melhor. Tens a certeza de que queres ignorar a gravação de uma resposta em vídeo?</p>',
  },
  skip_stage_with_record: {
    title: 'Tens a certeza de que queres ignorar a tarefa?',
    content:
      '<p>Vais ignorar a gravação da resposta em vídeo – esta não ficará acessível para a pessoa que conduz o processo de recrutamento. O envio de uma resposta em vídeo para esta tarefa não é obrigatório, mas é recomendado - ajudar-nos-á a conhecer-te melhor. Tens a certeza de que queres ignorar a gravação da resposta em vídeo?</p>',
  },
  instruction_camera: {
    content: `
      <span class="swal2-title">Resolução de Problemas com Câmara e Microfone</span>
      <hr>
      <div class="swal2-wrapper">
      <p>Se a gravação ou reprodução de vídeo não for efetuada corretamente, podes seguir alguns passos que devem resolver o problema. As causas mais comuns decorrem das definições do dispositivo, incluindo outros programas ou aplicações que estejam a utilizar a câmara e/ou o microfone em simultâneo.</p>
      <p>Possíveis soluções:</p>
      <ol>
        <li>Certifica-te de que o navegador tem permissões para usar o microfone e a câmara. Se não tiver, altera as definições e atualiza a página.</li>
        <li>Garante que nenhuma outra aplicação ou programa está a utilizar a câmara/microfone no momento (por exemplo, MS Teams, Photo Booth ou FaceTime) - fecha as aplicações que bloqueiam a utilização da câmara pelo navegador e atualiza a página.</li>
        <li>Verifica se o teu navegador está atualizado para a versão mais recente - se não estiver, faz a atualização e corre o teste novamente.</li>
        <li>Se os passos anteriores não ajudaram, tenta utilizar outro navegador ou dispositivo.</li>
      </ol>
      <p>Se o problema persistir, informa-nos em { supportEmail } enviando detalhes sobre o dispositivo e navegador onde o problema ocorre.</p>
      </div>
      <hr>
    `,
  },
  recaptcha: 'Marca o Recaptcha',
  phone_incorrect: 'Insere um número de telemóvel válido',
  missing_answer_error:
    'Para continuares, seleciona duas respostas: uma com o polegar para cima e outra com o polegar para baixo.',
  rotate_phone_video: 'Roda o telemóvel horizontalmente para veres o vídeo num tamanho maior',
  rotate_phone_image: 'Roda o telemóvel horizontalmente para veres a imagem num tamanho maior',
  attachments: 'Anexos',
  debugbar: {
    title: 'Posição do cursor',
    latutide: 'Latitude',
    longitude: 'Longitude',
    hint: 'Clica em qualquer lugar do ecrã para veres as coordenadas da posição do cursor',
  },
  loading: 'A carregar...',
};
